var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:[{ isChecked: _vm.isChecked }, { rounded: _vm.rounded }],on:{"click":function($event){return _vm.$emit('onCheckedToggle', !_vm.isChecked)}}})}
var staticRenderFns = []

export { render, staticRenderFns }